import React from 'react';
import Switch from './Switch';

import styles from './TitleSwitch.module.scss';

interface Props {
  title: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const TitleSwitch: React.FC<Props> = ({ title, checked, onChange }) => {
  return (
    <div className={styles.TitleSwitch}>
      <button
        id="title-switch-button"
        data-testid="title-switch-button"
        type="button"
        onClick={() => onChange(!checked)}
      >
        {title}
      </button>
      <Switch aria-labelledby="title-switch-button" isChecked={checked} onUpdate={onChange} />
    </div>
  );
};

export default TitleSwitch;
